<template>
    <div>
        <div class="setting-navigation">
            <template :key="'tab-item-' + i" v-for="(tab, i) in property.tabs">
                <span @click="activateTab(tab)" class="btn btn-sm tab" :class="[{ 'active-tab': tab.active }]">{{ tab.name }}</span>
            </template>
        </div>
        <div class="setting-content">
            <template :key="'tab-item-' + i" v-for="(tab, i) in property.tabs">
                <div v-if="tab.active" class="general p-3">
                    <template :key="'tab-group-' + i + '-' + j" v-for="(group, j) in tab.groups">
                        <h6 class="border-bottom mb-3">{{ group.name }}</h6>
                        <div class="row element-setting-contant-group">
                            <template :key="'tab-group-attribute' + i + '-' + j + '-' + k" v-for="(attribute, k) in group.attributes">
                                <div class="">
                                    <!-- Attribute Chooser themeStyle -->
                                    <template v-if="attribute.chooser == 'inputThemeStyle'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-title">
                                                <span class="title">{{ attribute.label }}</span>
                                                <span class="title-help" v-if="attribute.help !== ''"><i class="fas fa-info-circle text-info ms-1" :title="attribute.help"></i></span>
                                            </div>
                                            <div class="chooser-element-content">
                                                <select style="width: 120px" class="form-select form-select-sm rounded-1 select-input" v-model="elementSetting.props[attribute.attr.replace('props.', '')]">
                                                    <option value="">Default</option>
                                                    <option
                                                        v-if="
                                                            elementSetting.type == 'Heading' ||
                                                            elementSetting.type == 'Photo' ||
                                                            elementSetting.type == 'Separator' ||
                                                            elementSetting.type == 'Accordion' ||
                                                            elementSetting.type == 'Tab' ||
                                                            elementSetting.type == 'ContentSlider' ||
                                                            elementSetting.type == 'Gallery' ||
                                                            elementSetting.type == 'Callout' ||
                                                            elementSetting.type == 'Slider'
                                                        "
                                                        value="type-1"
                                                    >
                                                        Type 1
                                                    </option>
                                                    <option v-if="elementSetting.type == 'Heading'" value="type-2">Type 2</option>
                                                    <option v-if="elementSetting.type == 'Heading'" value="type-3">Type 3</option>
                                                    <option v-if="elementSetting.type == 'Heading'" value="type-4">Type 4</option>
                                                    <option v-if="elementSetting.type == 'Button'" value="theme primary">Primary</option>
                                                    <option v-if="elementSetting.type == 'Button'" value="theme secondary">Secondary</option>
                                                    <option v-if="elementSetting.type == 'Button'" value="theme link">Link</option>
                                                </select>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Attribute Chooser inputText -->
                                    <template v-if="attribute.chooser == 'inputText'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-title">
                                                <span class="title">{{ attribute.label }}</span>
                                                <span class="title-help" v-if="attribute.help !== ''"><i class="fas fa-info-circle text-info ms-1" :title="attribute.help"></i></span>
                                            </div>
                                            <div class="chooser-element-content">
                                                <input v-if="attribute.attr.includes('props.')" type="text" class="form-control form-control-sm text-input" v-model="elementSetting.props[attribute.attr.replace('props.', '')]" />
                                                <input v-else-if="attribute.attr.includes('style.')" type="text" class="form-control form-control-sm text-input" v-model="elementSetting.style[attribute.attr.replace('style.', '')]" />
                                                <input v-else type="text" class="form-control form-control-sm text-input" v-model="elementSetting[attribute.attr]" />
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Attribute Chooser inputObjectFit -->
                                    <template v-if="attribute.chooser == 'inputObjectFit'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-title">
                                                <span class="title">{{ attribute.label }}</span>
                                                <span class="title-help" v-if="attribute.help !== ''"><i class="fas fa-info-circle text-info ms-1" :title="attribute.help"></i></span>
                                            </div>
                                            <div class="chooser-element-content">
                                                <select class="form-select form-select-sm rounded-1 select-input" v-model="elementSetting.style[attribute.attr.replace('style.', '')]">
                                                    <option value="fill">fill</option>
                                                    <option value="contain">contain</option>
                                                    <option value="cover">cover</option>
                                                    <option value="none">none</option>
                                                    <option value="scale-down">scale-down</option>
                                                </select>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Attribute Chooser inputLink -->
                                    <template v-if="attribute.chooser == 'inputLink'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-title">
                                                <span class="title">{{ attribute.label }}</span>
                                                <span class="title-help" v-if="attribute.help !== ''"><i class="fas fa-info-circle text-info ms-1" :title="attribute.help"></i></span>
                                            </div>
                                            <div class="chooser-element-content">
                                                <div class="d-flex align-items-center" style="gap: 6px">
                                                    <span
                                                        v-if="attribute.attr.includes('props.') && isLinkToken(elementSetting.props[attribute.attr.replace('props.', '')])"
                                                        style="display: inline-flex; align-items: center; flex: 1; background: #fff; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12); border-radius: 4px; padding: 5px 8px; font-size: 13px; color: #333"
                                                    >
                                                        <i class="fas fa-link me-1 text-primary"></i>{{ linkTokenLabel(elementSetting.props[attribute.attr.replace("props.", "")]) }}
                                                        <a role="button" class="ms-auto text-danger" title="Remove" @click="elementSetting.props[attribute.attr.replace('props.', '')] = ''"><i class="fas fa-times"></i></a>
                                                    </span>
                                                    <input
                                                        v-else-if="attribute.attr.includes('props.')"
                                                        placeholder="http://www.example.com"
                                                        type="text"
                                                        class="form-control form-control-sm text-input"
                                                        v-model="elementSetting.props[attribute.attr.replace('props.', '')]"
                                                    />
                                                    <input v-else placeholder="http://www.example.com" type="text" class="form-control form-control-sm text-input" v-model="elementSetting[attribute.attr]" />
                                                    <button type="button" class="btn btn-light btn-sm" title="Link to a page" @click="openPageLinkForAttr(attribute.attr)"><i class="fas fa-file-alt"></i></button>
                                                </div>
                                                <div class="additionals-wrapper d-flex justify-content-between mt-1" v-if="elementSetting.props">
                                                    <div class="form-check">
                                                        <input type="checkbox" class="form-check-input" v-model="elementSetting.props.newWindow" />
                                                        <label for="">New Window</label>
                                                    </div>
                                                    <div class="form-check">
                                                        <input type="checkbox" class="form-check-input" v-model="elementSetting.props.noFollow" />
                                                        <label for="">No Follow</label>
                                                    </div>
                                                    <div class="form-check">
                                                        <input type="checkbox" class="form-check-input" v-model="elementSetting.props.forceDownload" />
                                                        <label for="">Force Download</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Attribute Chooser inputTextarea -->
                                    <template v-if="attribute.chooser == 'inputTextarea'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-title">
                                                <span class="title">{{ attribute.label }}</span>
                                                <span class="title-help" v-if="attribute.help !== ''"><i class="fas fa-info-circle text-info ms-1" :title="attribute.help"></i></span>
                                            </div>
                                            <div class="chooser-element-content">
                                                <textarea
                                                    v-if="attribute.attr.includes('props.')"
                                                    rows="3"
                                                    @input="changeSetting()"
                                                    type="text"
                                                    class="form-control form-control-sm text-input"
                                                    v-model="elementSetting.props[attribute.attr.replace('props.', '')]"
                                                />
                                                <textarea v-else type="text" rows="3" @input="changeSetting()" class="form-control form-control-sm text-input" v-model="elementSetting[attribute.attr]" />
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Attribute Chooser inputHeading -->
                                    <template v-if="attribute.chooser == 'inputHeadingTag'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-title">
                                                <span class="title">{{ attribute.label }}</span>
                                                <span class="title-help" v-if="attribute.help !== ''"><i class="fas fa-info-circle text-info ms-1" :title="attribute.help"></i></span>
                                            </div>
                                            <div class="chooser-element-content">
                                                <select style="width: 65px" class="form-select form-select-sm rounded-1 select-input" v-model="elementSetting.props[attribute.attr.replace('props.', '')]">
                                                    <option value="h2">h2</option>
                                                    <option value="h3">h3</option>
                                                    <option value="h4">h4</option>
                                                    <option value="h5">h5</option>
                                                    <option value="h6">h6</option>
                                                </select>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Attribute Chooser inputIconOpen / inputIconClose — heygov-style searchable FA picker (stores the unicode hex) -->
                                    <template v-if="attribute.chooser == 'inputIconOpen' || attribute.chooser == 'inputIconClose'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-title">
                                                <span class="title">{{ attribute.label }}</span>
                                                <span class="title-help" v-if="attribute.help !== ''"><i class="fas fa-info-circle text-info ms-1" :title="attribute.help"></i></span>
                                            </div>
                                            <div class="chooser-element-content">
                                                <div class="pb-icon-select">
                                                    <button type="button" class="pb-icon-control" @click="toggleAccordionIconDropdown(attribute.attr)">
                                                        <span class="pb-icon-current">
                                                            <font-awesome-icon :icon="['fas', getIconNameFromHex(elementSetting.props[attribute.attr.replace('props.', '')])]" />
                                                            <span class="pb-icon-name">{{ accordionIconLabel(elementSetting.props[attribute.attr.replace('props.', '')]) }}</span>
                                                        </span>
                                                        <i class="fas fa-chevron-down pb-icon-caret" :class="{ open: accordionIconDropdownFor === attribute.attr }"></i>
                                                    </button>
                                                    <div v-if="accordionIconDropdownFor === attribute.attr" class="pb-icon-dropdown">
                                                        <input v-model="accordionIconSearch" type="text" class="form-control form-control-sm pb-icon-search" placeholder="Search icons" />
                                                        <div class="pb-icon-list">
                                                            <button
                                                                v-for="ic in filteredAccordionIcons"
                                                                :key="ic.hex"
                                                                type="button"
                                                                class="pb-icon-option"
                                                                :class="{ active: elementSetting.props[attribute.attr.replace('props.', '')] === ic.hex }"
                                                                @click="selectAccordionIcon(attribute.attr, ic.hex)"
                                                            >
                                                                <font-awesome-icon :icon="['fas', ic.name]" class="pb-icon-glyph" />
                                                                <span class="pb-icon-label">{{ ic.label }}</span>
                                                            </button>
                                                            <div v-if="!filteredAccordionIcons.length" class="pb-icon-empty">No icons found</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Attribute Chooser inputColor -->
                                    <template v-if="attribute.chooser == 'inputColor'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-title">
                                                <span class="title">{{ attribute.label }}</span>
                                                <span class="title-help" v-if="attribute.help !== ''"><i class="fas fa-info-circle text-info ms-1" :title="attribute.help"></i></span>
                                            </div>
                                            <div class="chooser-element-content">
                                                <ColorPicker
                                                    v-on:change="elementSetting.props[attribute.attr.replace('props.', '')] = $event"
                                                    v-if="attribute.attr.includes('props.')"
                                                    :themeSettings="themeSettings"
                                                    :value="elementSetting.props[attribute.attr.replace('props.', '')]"
                                                />
                                                <ColorPicker
                                                    v-on:change="elementSetting.style[attribute.attr.replace('style.', '')] = $event"
                                                    v-else-if="attribute.attr.includes('style.')"
                                                    :themeSettings="themeSettings"
                                                    :value="elementSetting.style[attribute.attr.replace('style.', '')]"
                                                />
                                                <ColorPicker v-on:change="elementSetting[attribute.attr] = $event" v-else :themeSettings="themeSettings" :value="elementSetting[attribute.attr]" />
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Attribute Chooser inputWithUnit -->
                                    <template v-if="attribute.chooser == 'inputWithUnit'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-title">
                                                <span class="title">{{ attribute.label }}</span>
                                                <span class="title-help" v-if="attribute.help !== ''"><i class="fas fa-info-circle text-info ms-1" :title="attribute.help"></i></span>
                                            </div>
                                            <div class="chooser-element-content">
                                                <InputWithUnit :title="attribute.label" v-on:changeValue="elementSetting.style[attribute.attr.replace('style.', '')] = $event" :values="elementSetting.style[attribute.attr.replace('style.', '')]" />
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Attribute Chooser inputFourValues -->
                                    <template v-if="attribute.chooser == 'inputFourValues'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-title">
                                                <span class="title">{{ attribute.label }}</span>
                                                <span class="title-help" v-if="attribute.help !== ''"><i class="fas fa-info-circle text-info ms-1" :title="attribute.help"></i></span>
                                            </div>
                                            <div class="chooser-element-content">
                                                <SpacingControl
                                                    v-if="attribute.attr.includes('style.')"
                                                    :type="/radius/i.test(attribute.name || '') ? 'borderRadius' : 'padding'"
                                                    :value="elementSetting.style[attribute.attr.replace('style.', '')]"
                                                    v-on:change="elementSetting.style[attribute.attr.replace('style.', '')] = $event"
                                                />
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Attribute Chooser InputColumnSize -->
                                    <template v-if="attribute.chooser == 'inputColumnSize'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-title">
                                                <span class="title">{{ attribute.label }}</span>
                                                <span class="title-help" v-if="attribute.help !== ''"><i class="fas fa-info-circle text-info ms-1" :title="attribute.help"></i></span>
                                            </div>
                                            <div class="chooser-element-content">
                                                <select class="form-select form-select-sm rounded-1 select-input" v-model="elementSetting[attribute.attr]">
                                                    <option value="col-12 col-md-12 col-lg-12">1 Column (col-12)</option>
                                                    <option value="col-12 col-md-6 col-lg-6">2 Columns (col-6)</option>
                                                    <option value="col-12 col-md-4 col-lg-4">3 Columns (col-4)</option>
                                                    <option value="col-12 col-md-3 col-lg-3">4 Columns (col-3)</option>
                                                    <option value="col-12 col-md-2 col-lg-2">6 Columns (col-2)</option>
                                                    <option value="col-12 col-md-5 col-lg-5">(col-5)</option>
                                                    <option value="col-12 col-md-7 col-lg-7">(col-7)</option>
                                                    <option value="col-12 col-md-8 col-lg-8">(col-8)</option>
                                                    <option value="col-12 col-md-9 col-lg-9">(col-9)</option>
                                                    <option value="col-12 col-md-10 col-lg-10">(col-10)</option>
                                                </select>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Attribute Chooser inputImage -->
                                    <template v-if="attribute.chooser == 'inputImage'">
                                        <div class="chooser-element input-image">
                                            <div class="chooser-element-title">
                                                <div class="chooser-element-title">
                                                    <span class="title">{{ attribute.label }}</span>
                                                    <span class="title-help" v-if="attribute.help !== ''"><i class="fas fa-info-circle text-info ms-1" :title="attribute.help"></i></span>
                                                </div>
                                            </div>
                                            <div class="chooser-element-content">
                                                <div class="src-wrapper d-flex justify-content-start align-items-end">
                                                    <div class="form-group w-100">
                                                        <input v-if="attribute.attr.includes('props.')" type="text" class="form-control text-input" v-model="elementSetting.props[attribute.attr.replace('props.', '')]" />
                                                        <input v-else-if="attribute.attr.includes('style.')" type="text" class="form-control text-input" v-model="elementSetting.style[attribute.attr.replace('style.', '')]" />
                                                        <input v-else type="text" class="form-control text-input" v-model="elementSetting[attribute.attr]" />
                                                    </div>
                                                    <button class="btn btn-primary btn-sm text-white" @click="showWordpressMediaLibraryModal(attribute.attr)">
                                                        <i class="fas fa-photo-video"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Attribute Chooser inputBackgroundSize -->
                                    <template v-if="attribute.chooser == 'inputBackgroundSize'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-title">
                                                <span class="title">{{ attribute.label }}</span>
                                                <span class="title-help" v-if="attribute.help !== ''"><i class="fas fa-info-circle text-info ms-1" :title="attribute.help"></i></span>
                                            </div>
                                            <div class="chooser-element-content">
                                                <select class="form-select form-select-sm rounded-1 select-input" v-model="elementSetting.style[attribute.attr.replace('style.', '')]">
                                                    <option value="">Select</option>
                                                    <option value="auto">auto</option>
                                                    <option value="contain">contain</option>
                                                    <option value="cover">cover</option>
                                                    <option value="inherit">inherit</option>
                                                    <option value="unset">unset</option>
                                                </select>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Attribute Chooser inputBackgroundPosition -->
                                    <template v-if="attribute.chooser == 'inputBackgroundPosition'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-title">
                                                <span class="title">{{ attribute.label }}</span>
                                                <span class="title-help" v-if="attribute.help !== ''"><i class="fas fa-info-circle text-info ms-1" :title="attribute.help"></i></span>
                                            </div>
                                            <div class="chooser-element-content">
                                                <select class="form-select form-select-sm rounded-1 select-input" v-model="elementSetting.style[attribute.attr.replace('style.', '')]">
                                                    <option value="">Select</option>
                                                    <option value="bottom">bottom</option>
                                                    <option value="top">top</option>
                                                    <option value="center">center</option>
                                                    <option value="left">left</option>
                                                    <option value="right">right</option>
                                                    <option value="unset">unset</option>
                                                </select>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Attribute Chooser inputBackgroundRepeat -->
                                    <template v-if="attribute.chooser == 'inputBackgroundRepeat'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-title">
                                                <span class="title">{{ attribute.label }}</span>
                                                <span class="title-help" v-if="attribute.help !== ''"><i class="fas fa-info-circle text-info ms-1" :title="attribute.help"></i></span>
                                            </div>
                                            <div class="chooser-element-content">
                                                <select class="form-select form-select-sm rounded-1 select-input" v-model="elementSetting.style[attribute.attr.replace('style.', '')]">
                                                    <option value="">Select</option>
                                                    <option value="no-repeat">no-repeat</option>
                                                    <option value="repeat">repeat</option>
                                                    <option value="repeat-x">repeat-x</option>
                                                    <option value="repeat-y">repeat-y</option>
                                                    <option value="round">round</option>
                                                    <option value="space">space</option>
                                                    <option value="unset">unset</option>
                                                </select>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Attribute Chooser inputItemsPerRow -->
                                    <template v-if="attribute.chooser == 'inputItemsPerRow'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-title">
                                                <span class="title">{{ attribute.label }}</span>
                                                <span class="title-help" v-if="attribute.help !== ''"><i class="fas fa-info-circle text-info ms-1" :title="attribute.help"></i></span>
                                            </div>
                                            <div class="chooser-element-content">
                                                <select class="form-select form-select-sm rounded-1 select-input" v-model="elementSetting.props[attribute.attr.replace('props.', '')]">
                                                    <option value="2">2</option>
                                                    <option value="3">3</option>
                                                    <option value="4">4</option>
                                                    <option value="6">6</option>
                                                </select>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Attribute Chooser inputCheckbox -->
                                    <template v-if="attribute.chooser == 'inputCheckbox' && shouldShowPropertyAttribute(attribute)">
                                        <div class="chooser-element">
                                            <div class="chooser-element-title">
                                                <span class="title">{{ attribute.label }}</span>
                                                <span class="title-help" v-if="attribute.help !== ''"><i class="fas fa-info-circle text-info ms-1" :title="attribute.help"></i></span>
                                            </div>
                                            <div class="chooser-element-content">
                                                <div class="form-check d-flex justify-content-start align-items-center">
                                                    <input v-if="attribute.attr.includes('props.')" type="checkbox" class="form-check-input" v-model="elementSetting.props[attribute.attr.replace('props.', '')]" />
                                                    <input v-else-if="attribute.attr.includes('style.')" type="checkbox" class="form-check-input" v-model="elementSetting.style[attribute.attr.replace('style.', '')]" />
                                                    <input v-else type="checkbox" class="form-check-input" v-model="elementSetting[attribute.attr]" />
                                                </div>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Attribute Chooser inputMiliseconds -->
                                    <template v-if="attribute.chooser == 'inputMiliseconds'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-title">
                                                <span class="title">{{ attribute.label }}</span>
                                                <span class="title-help" v-if="attribute.help !== ''"><i class="fas fa-info-circle text-info ms-1" :title="attribute.help"></i></span>
                                            </div>
                                            <div class="chooser-element-content">
                                                <div class="input-group input-group-sm">
                                                    <input class="form-control form-control-sm text-input" type="number" min="0" max="20000" v-model="elementSetting.props[attribute.attr.replace('props.', '')]" />
                                                    <span class="input-group-text input-group-sm select-input">ms</span>
                                                </div>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Attribute Chooser inputTextEditor -->
                                    <template v-if="attribute.chooser == 'inputTextEditor'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-content w-100 h-100">
                                                <span class="title">{{ attribute.label }}</span>
                                                <span class="title-help" v-if="attribute.help !== ''"><i class="fas fa-info-circle text-info ms-1" :title="attribute.help"></i></span>
                                                <div class="pb-text-editor">
                                                    <editor
                                                        v-if="attribute.attr.includes('props.')"
                                                        api-key=""
                                                        v-model="elementSetting.props[attribute.attr.replace('props.', '')]"
                                                        class=""
                                                        theme="advanced"
                                                        theme_advanced_toolbar_location="top"
                                                        :init="tinymcInit"
                                                        @execCommand="tinyMCEMedLib"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Attribute Chooser inputCodeEditor -->
                                    <template v-if="attribute.chooser == 'inputCodeEditor'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-content w-100 h-100">
                                                <span class="title">{{ attribute.label }}</span>
                                                <span class="title-help" v-if="attribute.help !== ''"><i class="fas fa-info-circle text-info ms-1" :title="attribute.help"></i></span>
                                                <!-- TODO -->
                                                <CodeEditor
                                                    :languages="[
                                                        ['html', 'HTML'],
                                                        ['javascript', 'JS'],
                                                    ]"
                                                    :line-nums="true"
                                                    v-model="elementSetting.props[attribute.attr.replace('props.', '')]"
                                                ></CodeEditor>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Attribute Chooser inputGalleryItems -->
                                    <template v-if="attribute.chooser == 'inputGalleryItems'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-title">
                                                <span class="title">{{ attribute.label }}</span>
                                                <span class="title-help" v-if="attribute.help !== ''"><i class="fas fa-info-circle text-info ms-1" :title="attribute.help"></i></span>
                                            </div>
                                            <div class="chooser-element-content">
                                                <div class="row">
                                                    <draggable ghost-class="ghost" class="dragArea row" :list="elementSetting.props[attribute.attr.replace('props.', '')]" :group="{ name: 'blocks' }">
                                                        <div class="col-md-6 mb-2" v-for="(item, index) in elementSetting.props[attribute.attr.replace('props.', '')]" :key="'gallery-item-' + index">
                                                            <div class="gallery-item">
                                                                <div class="image">
                                                                    <span>{{ index + 1 }}</span>
                                                                    <img v-if="item.image && item.image !== '' && item.image !== 'null'" @click="showWordpressMediaLibraryModal(item)" class="gallery-item-preview" :src="item.image" alt="" />
                                                                    <div v-else class="gallery-item-no-image" @click="showWordpressMediaLibraryModal(item)">Select</div>
                                                                </div>
                                                                <div class="content">
                                                                    <input type="text" placeholder="title" v-model="item.title" class="" />

                                                                    <div class="actions">
                                                                        <a role="button" class="btn btn-primary btn-sm" @click="showWordpressMediaLibraryModal(item)"><i class="fas fa-images"></i></a>
                                                                        <button v-if="index > 0" class="btn btn-danger btn-sm remove-gallery-item" @click="removePropertyItem(item.id)">
                                                                            <i class="fas fa-trash"></i>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6 mb-2" style="padding: 10px 20px 10px 20px">
                                                            <button class="btn btn-outline-primary btn-sm w-100 gallery-item text-center" @click="addPropertyItem('gallery')" style="height: 100px; padding-left: 20px">Add item</button>
                                                        </div>
                                                    </draggable>
                                                </div>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Attribute Chooser inputSliderItems -->
                                    <template v-if="attribute.chooser == 'inputSliderItems'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-content">
                                                <div class="row">
                                                    <draggable ghost-class="ghost" class="dragArea row" :list="elementSetting.props[attribute.attr.replace('props.', '')]" :group="{ name: 'blocks' }">
                                                        <div class="col-md-6 mb-2" v-for="(item, index) in elementSetting.props[attribute.attr.replace('props.', '')]" :key="'gallery-item-' + index">
                                                            <div class="gallery-item">
                                                                <div class="image">
                                                                    <span>{{ index + 1 }}</span>
                                                                    <img v-if="item.image && item.image !== '' && item.image !== 'null'" @click="showWordpressMediaLibraryModal(item)" class="gallery-item-preview" :src="item.image" alt="" />
                                                                    <div v-else class="gallery-item-no-image" @click="showWordpressMediaLibraryModal(item)">Select</div>
                                                                </div>
                                                                <div class="content">
                                                                    <input type="text" placeholder="title" v-model="item.title" class="" />
                                                                    <textarea placeholder="" v-model="item.text" rows="3" class="w-100" />

                                                                    <div class="actions">
                                                                        <a role="button" class="btn btn-primary btn-sm d-none" @click="showWordpressMediaLibraryModal(item)"><i class="fas fa-images"></i></a>
                                                                        <button v-if="index > 1" class="btn btn-danger btn-sm remove-gallery-item" @click="removePropertyItem(item.id)">
                                                                            <i class="fas fa-trash"></i>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6 mb-2" style="padding: 10px 20px 10px 20px">
                                                            <button class="btn btn-outline-primary btn-sm w-100 gallery-item text-center" @click="addPropertyItem('slider')" style="height: 100px; padding-left: 20px">Add item</button>
                                                        </div>
                                                    </draggable>
                                                </div>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Attribute Chooser inputContentSliderItems -->
                                    <template v-if="attribute.chooser == 'inputContentSliderItems'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-content">
                                                <div class="row">
                                                    <draggable ghost-class="ghost" class="dragArea row" :list="elementSetting.props[attribute.attr.replace('props.', '')]" :group="{ name: 'blocks' }">
                                                        <div class="col-md-12 mb-2" v-for="(item, index) in elementSetting.props[attribute.attr.replace('props.', '')]" :key="'gallery-item-' + index">
                                                            <div class="gallery-item">
                                                                <div class="video" v-if="item.type && item.type == 'video+text'">
                                                                    <textarea type="text" class="" v-model="item.video" placeholder="Add video URL" />
                                                                </div>
                                                                <div class="image" v-if="item.type && item.type == 'image+text'">
                                                                    <img v-if="item.image && item.image !== '' && item.image !== 'null'" @click="showWordpressMediaLibraryModal(item)" class="gallery-item-preview" :src="item.image" alt="" />
                                                                    <div v-else class="gallery-item-no-image" @click="showWordpressMediaLibraryModal(item)">Select</div>
                                                                </div>
                                                                <div class="content">
                                                                    <div class="d-flex justify-content-between align-items-center w-100">
                                                                        <input type="text" placeholder="Heading" v-model="item.heading" class="" />
                                                                        <select class="" v-model="item.type">
                                                                            <option value="text">Text</option>
                                                                            <option value="text+image">Text & Image</option>
                                                                            <option value="text+video">Text & Video</option>
                                                                            <option value="image+text">Image & Text</option>
                                                                            <option value="video+text">Video & Text</option>
                                                                        </select>
                                                                    </div>
                                                                    <button class="btn btn-outline-primary btn-sm mb-2" @click="item.showContent = true" v-if="!item.showContent">Show Content</button>
                                                                    <div class="jp-elements-item-editor w-100" v-if="item.showContent">
                                                                        <editor api-key="" v-model="item.text" class="" theme="advanced" theme_advanced_toolbar_location="top" :init="tinymcInit" @execCommand="tinyMCEMedLib" />
                                                                    </div>
                                                                    <button class="btn btn-outline-primary btn-sm mb-2" @click="item.showContent = false" v-if="item.showContent">Hide Content</button>
                                                                    <div class="actions">
                                                                        <a role="button" class="btn btn-primary btn-sm d-none" @click="showWordpressMediaLibraryModal(item)"><i class="fas fa-images"></i></a>
                                                                        <button v-if="index > 1" class="btn btn-danger btn-sm remove-gallery-item" @click="removePropertyItem(item.id)">
                                                                            <i class="fas fa-trash"></i>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                                <div class="image" v-if="item.type && item.type == 'text+image'">
                                                                    <img v-if="item.image && item.image !== '' && item.image !== 'null'" @click="showWordpressMediaLibraryModal(item)" class="gallery-item-preview" :src="item.image" alt="" />
                                                                    <div v-else class="gallery-item-no-image" @click="showWordpressMediaLibraryModal(item)">Select</div>
                                                                </div>
                                                                <div class="video" v-if="item.type && item.type == 'text+video'">
                                                                    <textarea type="text" class="" v-model="item.video" placeholder="Add video URL" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </draggable>
                                                    <div class="col-md-12 mb-2 text-center">
                                                        <button class="btn btn-primary btn-sm" @click="addPropertyItem('contentSlider')">+ Add Item</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Attribute Chooser inputAccordionItems -->
                                    <template v-if="attribute.chooser == 'inputAccordionItems'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-content position-relative p-4">
                                                <div v-show="accordionSorting" class="position-absolute start-0 end-0 top-0 bottom-0 opacity-75 bg-white" style="z-index: 9999"></div>
                                                <draggable
                                                    ghost-class="ghost"
                                                    class="dragArea row"
                                                    :list="elementSetting.props[attribute.attr.replace('props.', '')]"
                                                    :group="{ name: 'blocks' }"
                                                    @end="onDragEnd($event, 'accordion')"
                                                    :key="componentKey"
                                                >
                                                    <div class="col-md-12 mb-2" v-for="(item, index) in elementSetting.props[attribute.attr.replace('props.', '')]" :key="'element-item-' + index">
                                                        <div class="element-item">
                                                            <div class="content">
                                                                <div class="form-group mb-2">
                                                                    <label for="">Title</label>
                                                                    <input type="text" class="form-control form-control-sm" placeholder="title" v-model="item.title" />
                                                                </div>
                                                                <div class="pb-text-editor">
                                                                    <editor api-key="" v-model="item.content" class="" theme="advanced" theme_advanced_toolbar_location="top" :init="tinymcInit" @execCommand="tinyMCEMedLib" />
                                                                </div>
                                                                <!-- collapse === true → item initially open (same key the published output reads) -->
                                                                <div class="form-check mt-2">
                                                                    <input class="form-check-input" type="checkbox" :id="'accordion-item-open-' + index" v-model="item.collapse" />
                                                                    <label class="form-check-label" :for="'accordion-item-open-' + index">Open by default</label>
                                                                </div>
                                                                <div class="actions">
                                                                    <a role="button" class="btn btn-primary btn-sm d-none" @click="showWordpressMediaLibraryModal(item)"><i class="fas fa-images"></i></a>
                                                                    <button v-if="index > 0" class="btn btn-danger btn-sm element-item-remove" @click="removePropertyItem(item.id)">
                                                                        <i class="fas fa-trash"></i>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <hr />
                                                    </div>
                                                    <div class="col-md-12 mb-2" style="padding: 10px 20px 10px 20px">
                                                        <button class="btn btn-primary btn-sm w-100 element-item" @click="addPropertyItem('accordion')">Add item</button>
                                                    </div>
                                                </draggable>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Attribute Chooser inputTabItems -->
                                    <template v-if="attribute.chooser == 'inputTabItems'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-content">
                                                <draggable ghost-class="ghost" class="dragArea row" :list="elementSetting.props[attribute.attr.replace('props.', '')]" :group="{ name: 'blocks' }">
                                                    <div class="col-md-12 mb-2" v-for="(item, index) in elementSetting.props[attribute.attr.replace('props.', '')]" :key="'element-item-' + index">
                                                        <div class="element-item">
                                                            <div class="content">
                                                                <div class="form-group mb-2">
                                                                    <label for="">Title</label>
                                                                    <input type="text" placeholder="title" v-model="item.title" class="form-control" />
                                                                </div>
                                                                <div class="pb-text-editor">
                                                                    <editor api-key="" v-model="item.content" class="" theme="advanced" theme_advanced_toolbar_location="top" :init="tinymcInit" @execCommand="tinyMCEMedLib" />
                                                                </div>
                                                                <div class="actions">
                                                                    <a role="button" class="btn btn-primary btn-sm d-none" @click="showWordpressMediaLibraryModal(item)"><i class="fas fa-images"></i></a>
                                                                    <button v-if="index > 0" class="btn btn-danger btn-sm element-item-remove" @click="removePropertyItem(item.id)">
                                                                        <i class="fas fa-trash"></i>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12 mb-2">
                                                        <button class="btn btn-primary btn-sm w-100 element-item" @click="addPropertyItem('tab')">Add item</button>
                                                    </div>
                                                </draggable>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Attribute Chooser inputAlign -->
                                    <template v-if="attribute.chooser == 'inputAlign'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-title">
                                                <span class="title">{{ attribute.label }}</span>
                                                <span class="title-help" v-if="attribute.help !== ''"><i class="fas fa-info-circle text-info ms-1" :title="attribute.help"></i></span>
                                            </div>
                                            <div class="chooser-element-content">
                                                <div class="chooser-align-wrapper">
                                                    <button
                                                        @click="elementSetting.style[attribute.attr.replace('style.', '')] = 'left'"
                                                        class="align-btn"
                                                        :class="[{ active: elementSetting.style[attribute.attr.replace('style.', '')] == 'left' }]"
                                                    >
                                                        <i class="fas fa-align-left"></i>
                                                    </button>
                                                    <button
                                                        @click="elementSetting.style[attribute.attr.replace('style.', '')] = 'center'"
                                                        class="align-btn"
                                                        :class="[{ active: elementSetting.style[attribute.attr.replace('style.', '')] == 'center' }]"
                                                    >
                                                        <i class="fas fa-align-center"></i>
                                                    </button>
                                                    <button
                                                        @click="elementSetting.style[attribute.attr.replace('style.', '')] = 'right'"
                                                        class="align-btn"
                                                        :class="[{ active: elementSetting.style[attribute.attr.replace('style.', '')] == 'right' }]"
                                                    >
                                                        <i class="fas fa-align-right"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Attribute Chooser inputCalloutImagePosition -->
                                    <template v-if="attribute.chooser == 'inputCalloutImagePosition'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-title">
                                                <span class="title">{{ attribute.label }}</span>
                                                <span class="title-help" v-if="attribute.help !== ''"><i class="fas fa-info-circle text-info ms-1" :title="attribute.help"></i></span>
                                            </div>
                                            <div class="chooser-element-content">
                                                <select class="form-select form-select-sm rounded-1 select-input" v-model="elementSetting.props[attribute.attr.replace('props.', '')]">
                                                    <option value="AboveHeading">Above Heading</option>
                                                    <option value="BelowHeading">Below Heading</option>
                                                    <option value="LeftOfTextAndHeading">Left Of Text And Heading</option>
                                                    <option value="RightOfTextAndHeading">Right Of Text And Heading</option>
                                                </select>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Attribute Chooser inputBorderStyle -->
                                    <template v-if="attribute.chooser == 'inputBorderStyle'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-title">
                                                <span class="title">{{ attribute.label }}</span>
                                                <span class="title-help" v-if="attribute.help !== ''"><i class="fas fa-info-circle text-info ms-1" :title="attribute.help"></i></span>
                                            </div>
                                            <div class="chooser-element-content">
                                                <select class="form-select form-select-sm rounded-1" style="width: 116px" v-model="elementSetting.style[attribute.attr.replace('style.', '')]">
                                                    <option value="solid">Solid</option>
                                                    <option value="dashed">Dashed</option>
                                                    <option value="dotted">Dotted</option>
                                                    <option value="double">Double</option>
                                                </select>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Attribute Chooser inputBorderStyle -->
                                    <template v-if="attribute.chooser == 'inputTextDecoration'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-title">
                                                <span class="title">{{ attribute.label }}</span>
                                                <span class="title-help" v-if="attribute.help !== ''"><i class="fas fa-info-circle text-info ms-1" :title="attribute.help"></i></span>
                                            </div>
                                            <div class="chooser-element-content">
                                                <select class="form-select form-select-sm rounded-1" style="width: 130px" v-model="elementSetting.style[attribute.attr.replace('style.', '')]">
                                                    <option value="none">None</option>
                                                    <option value="overline">Overline</option>
                                                    <option value="underline">Underline</option>
                                                    <option value="line-through">Line Through</option>
                                                </select>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Attribute Chooser inputTextVerticalPosition -->
                                    <template v-if="attribute.chooser == 'inputTextVerticalPosition'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-title">
                                                <span class="title">{{ attribute.label }}</span>
                                                <span class="title-help" v-if="attribute.help !== ''"><i class="fas fa-info-circle text-info ms-1" :title="attribute.help"></i></span>
                                            </div>
                                            <div class="chooser-element-content">
                                                <select class="form-select form-select-sm rounded-1" style="width: 130px" v-model="elementSetting.style[attribute.attr.replace('style.', '')]">
                                                    <option value="top">None</option>
                                                    <option value="start">Top</option>
                                                    <option value="center">Center</option>
                                                    <option value="end">Bottom</option>
                                                </select>
                                            </div>
                                        </div>
                                    </template>


                                    <template v-if="attribute.chooser == 'inputBusinessDirectoryCategoryMode'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-title">
                                                <span class="title">{{ attribute.label }}</span>
                                            </div>
                                            <div class="chooser-element-content">
                                                <select class="form-select form-select-sm rounded-1 select-input" v-model="elementSetting.props[attribute.attr.replace('props.', '')]">
                                                    <option value="all">All Categories</option>
                                                    <option value="single">Single Category</option>
                                                </select>
                                            </div>
                                        </div>
                                    </template>

                                    <template v-if="attribute.chooser == 'inputBusinessDirectoryCategory'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-title">
                                                <span class="title">{{ attribute.label }}</span>
                                            </div>
                                            <div class="chooser-element-content">
                                                <select class="form-select form-select-sm rounded-1 select-input" v-model="elementSetting.props[attribute.attr.replace('props.', '')]">
                                                    <option value="">Select category</option>
                                                    <option v-for="category in businessDirectoryCategories" :key="`bd-category-${category.id}`" :value="String(category.id)">
                                                        {{ category.name }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </template>

                                    <template v-if="attribute.chooser == 'inputBusinessDirectoryViewMode'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-title">
                                                <span class="title">{{ attribute.label }}</span>
                                            </div>
                                            <div class="chooser-element-content">
                                                <select class="form-select form-select-sm rounded-1 select-input" v-model="elementSetting.props[attribute.attr.replace('props.', '')]">
                                                    <option value="cards">Cards</option>
                                                    <option value="table">Table</option>
                                                </select>
                                            </div>
                                        </div>
                                    </template>

                                    <template v-if="attribute.chooser == 'inputBusinessDirectoryCardsPerRow'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-title">
                                                <span class="title">{{ attribute.label }}</span>
                                            </div>
                                            <div class="chooser-element-content">
                                                <select class="form-select form-select-sm rounded-1 select-input" v-model="elementSetting.props[attribute.attr.replace('props.', '')]">
                                                    <option value="2">2 (col-md-6)</option>
                                                    <option value="3">3 (col-md-4)</option>
                                                    <option value="4">4 (col-md-3)</option>
                                                </select>
                                            </div>
                                        </div>
                                    </template>

                                    <template v-if="attribute.chooser == 'inputBusinessDirectoryColumns'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-title">
                                                <span class="title">{{ attribute.label }}</span>
                                            </div>
                                            <div class="chooser-element-content">
                                                <div class="d-flex flex-wrap gap-2">
                                                    <label v-for="option in businessDirectoryColumnOptions" :key="`bd-col-${option.value}`" class="form-check me-3">
                                                        <input
                                                            class="form-check-input"
                                                            type="checkbox"
                                                            :checked="isBusinessDirectoryColumnSelected(option.value)"
                                                            @change="toggleBusinessDirectoryColumn(option.value, $event.target.checked)"
                                                        />
                                                        <span class="form-check-label">{{ option.label }}</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </template>

                                    <template v-if="attribute.chooser == 'inputBusinessDirectoryCreate'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-title">
                                                <span class="title">{{ attribute.label }}</span>
                                            </div>
                                            <div class="chooser-element-content">
                                                <button type="button" class="btn btn-sm btn-primary" @click="openCreateBusinessDirectoryModal">Add Business Directory Item</button>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Attribute Chooser inputFontWeight -->
                                    <template v-if="attribute.chooser == 'inputFontWeight'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-title">
                                                <span class="title">{{ attribute.label }}</span>
                                                <span class="title-help" v-if="attribute.help !== ''"><i class="fas fa-info-circle text-info ms-1" :title="attribute.help"></i></span>
                                            </div>
                                            <div class="chooser-element-content">
                                                <select class="form-select form-select-sm rounded-1 select-input" style="width: 150px" v-model="elementSetting.style[attribute.attr.replace('style.', '')]">
                                                    <option value="">Default</option>
                                                    <option value="300">Light (300)</option>
                                                    <option value="400">Normal (400)</option>
                                                    <option value="500">Medium (500)</option>
                                                    <option value="600">Semi Bold (600)</option>
                                                    <option value="700">Bold (700)</option>
                                                    <option value="800">Extra Bold (800)</option>
                                                    <option value="900">Black (900)</option>
                                                </select>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Attribute Chooser inputIconSelect (FA7 icon picker + color/size) -->
                                    <template v-if="attribute.chooser == 'inputIconSelect'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-title">
                                                <span class="title">{{ attribute.label }}</span>
                                                <span class="title-help" v-if="attribute.help !== ''"><i class="fas fa-info-circle text-info ms-1" :title="attribute.help"></i></span>
                                            </div>
                                            <div class="chooser-element-content">
                                                <IconSelect
                                                    :value="elementSetting.props[attribute.attr.replace('props.', '')]"
                                                    v-on:change="elementSetting.props[attribute.attr.replace('props.', '')] = $event"
                                                />
                                                <template v-if="elementSetting.props[attribute.attr.replace('props.', '')]">
                                                    <div class="mt-2"><small class="text-muted">Icon Color</small></div>
                                                    <ColorChooser :themeSettings="themeSettings" :value="elementSetting.style.iconColor" v-on:change="elementSetting.style.iconColor = $event" />
                                                    <div class="mt-2"><small class="text-muted">Icon Hover Color</small></div>
                                                    <ColorChooser :themeSettings="themeSettings" :value="elementSetting.style.iconColorHover" v-on:change="elementSetting.style.iconColorHover = $event" />
                                                    <div class="mt-2"><small class="text-muted">Icon Size</small></div>
                                                    <InputWithUnit title="Icon Size" :values="elementSetting.style.iconSize" v-on:changeValue="elementSetting.style.iconSize = $event" />
                                                </template>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Attribute Chooser inputOpacity -->
                                    <template v-if="attribute.chooser == 'inputOpacity'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-title">
                                                <span class="title">{{ attribute.label }}</span>
                                                <span class="title-help" v-if="attribute.help !== ''"><i class="fas fa-info-circle text-info ms-1" :title="attribute.help"></i></span>
                                            </div>
                                            <div class="chooser-element-content">
                                                <div class="d-flex align-items-center gap-2">
                                                    <input type="range" min="0" max="1" step="0.01" style="flex: 1" v-model.number="elementSetting.style[attribute.attr.replace('style.', '')]" />
                                                    <input type="number" min="0" max="1" step="0.01" class="form-control form-control-sm text-input" style="width: 80px" v-model.number="elementSetting.style[attribute.attr.replace('style.', '')]" />
                                                </div>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Attribute Chooser inputSelect (generic, options from attribute.options) -->
                                    <template v-if="attribute.chooser == 'inputSelect'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-title">
                                                <span class="title">{{ attribute.label }}</span>
                                                <span class="title-help" v-if="attribute.help !== ''"><i class="fas fa-info-circle text-info ms-1" :title="attribute.help"></i></span>
                                            </div>
                                            <div class="chooser-element-content">
                                                <select v-if="attribute.attr.includes('props.')" class="form-select form-select-sm rounded-1 select-input" v-model="elementSetting.props[attribute.attr.replace('props.', '')]">
                                                    <option v-for="opt in attribute.options" :key="'opt-' + opt.value" :value="opt.value">{{ opt.label }}</option>
                                                </select>
                                                <select v-else class="form-select form-select-sm rounded-1 select-input" v-model="elementSetting.style[attribute.attr.replace('style.', '')]">
                                                    <option v-for="opt in attribute.options" :key="'opt-' + opt.value" :value="opt.value">{{ opt.label }}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Attribute Chooser inputColorWithHex (base + optional hover when attribute.hover === true) -->
                                    <template v-if="attribute.chooser == 'inputColorWithHex'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-title">
                                                <span class="title">{{ attribute.label }}</span>
                                                <span class="title-help" v-if="attribute.help !== ''"><i class="fas fa-info-circle text-info ms-1" :title="attribute.help"></i></span>
                                            </div>
                                            <div class="chooser-element-content">
                                                <ColorPicker
                                                    v-if="attribute.attr.includes('props.')"
                                                    :themeSettings="themeSettings"
                                                    :hover="attribute.hover === true"
                                                    :value="elementSetting.props[attribute.attr.replace('props.', '')]"
                                                    :hoverValue="elementSetting.props[attribute.attr.replace('props.', '') + 'Hover']"
                                                    v-on:change="elementSetting.props[attribute.attr.replace('props.', '')] = $event"
                                                    v-on:changeHover="elementSetting.props[attribute.attr.replace('props.', '') + 'Hover'] = $event"
                                                />
                                                <ColorPicker
                                                    v-else
                                                    :themeSettings="themeSettings"
                                                    :hover="attribute.hover === true"
                                                    :value="elementSetting.style[attribute.attr.replace('style.', '')]"
                                                    :hoverValue="elementSetting.style[attribute.attr.replace('style.', '') + 'Hover']"
                                                    v-on:change="elementSetting.style[attribute.attr.replace('style.', '')] = $event"
                                                    v-on:changeHover="elementSetting.style[attribute.attr.replace('style.', '') + 'Hover'] = $event"
                                                />
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Attribute Chooser inputBorder (single string; + optional hover) -->
                                    <template v-if="attribute.chooser == 'inputBorder'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-title">
                                                <span class="title">{{ attribute.label }}</span>
                                                <span class="title-help" v-if="attribute.help !== ''"><i class="fas fa-info-circle text-info ms-1" :title="attribute.help"></i></span>
                                            </div>
                                            <div class="chooser-element-content">
                                                <BorderControl
                                                    :hover="attribute.hover === true"
                                                    :value="elementSetting.style[attribute.attr.replace('style.', '')]"
                                                    :hoverValue="elementSetting.style[attribute.attr.replace('style.', '') + 'Hover']"
                                                    v-on:change="elementSetting.style[attribute.attr.replace('style.', '')] = $event"
                                                    v-on:changeHover="elementSetting.style[attribute.attr.replace('style.', '') + 'Hover'] = $event"
                                                />
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Attribute Chooser inputNumber (+min/max) -->
                                    <template v-if="attribute.chooser == 'inputNumber'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-title">
                                                <span class="title">{{ attribute.label }}</span>
                                                <span class="title-help" v-if="attribute.help !== ''"><i class="fas fa-info-circle text-info ms-1" :title="attribute.help"></i></span>
                                            </div>
                                            <div class="chooser-element-content">
                                                <input
                                                    v-if="attribute.attr.includes('props.')"
                                                    type="number"
                                                    class="form-control form-control-sm text-input"
                                                    :min="attribute.min"
                                                    :max="attribute.max"
                                                    v-model.number="elementSetting.props[attribute.attr.replace('props.', '')]"
                                                />
                                                <input
                                                    v-else
                                                    type="number"
                                                    class="form-control form-control-sm text-input"
                                                    :min="attribute.min"
                                                    :max="attribute.max"
                                                    v-model.number="elementSetting.style[attribute.attr.replace('style.', '')]"
                                                />
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Attribute Chooser inputCodeEditor -->
                                    <template v-if="attribute.chooser == 'inputCustomCss'">
                                        <div class="chooser-element">
                                            <div class="chooser-element-content w-100 h-100">
                                                <span class="title">{{ attribute.label }}</span>
                                                <span class="title-help" v-if="attribute.help !== ''"><i class="fas fa-info-circle text-info ms-1" :title="attribute.help"></i></span>
                                                <br />
                                                <span>ID: {{ elementSetting.id }}</span>
                                                <!-- TODO -->
                                                <CodeEditor :languages="[['css', 'CSS']]" :line-nums="true" v-model="elementSetting.style[attribute.attr.replace('style.', '')]"></CodeEditor>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </template>
                        </div>
                    </template>
                </div>
            </template>
            <div class="d-flex justify-content-between align-items-center">
                <button @click="cancelChanges()" class="btn btn-secondary">Cancel</button>
                <button @click="closeElementSetting()" class="btn btn-primary">Apply</button>
            </div>
        </div>
    </div>
    <WordpressMediaLibraryModal v-on:mediaInsert="insertPhoto($event)" ref="wordpressMediaLibraryModal" />
    <CreateBusinessDirectoryModal ref="createBusinessDirectoryModal" :editing="false" @directorySaved="handleBusinessDirectorySaved" />
    <PageLinkModal ref="pageLinkModal" @select="onPageSelected($event)" />
</template>

<script>
import pageBuilderMixin from "@/mixins/pageBuilderMixin";
import { VueDraggableNext } from "vue-draggable-next";
import WordpressMediaLibraryModal from "@/components/modals/WordpressMediaLibraryModal";
import CreateBusinessDirectoryModal from "@/components/modals/CreateBusinessDirectoryModal";
import PageLinkModal from "@/components/modals/PageLinkModal";
import ColorChooser from "@/components/page-builder/elements/parts/choosers/ColorChooser";
import ColorPicker from "@/components/page-builder/elements/parts/choosers/ColorPicker";
import InputWithUnit from "@/components/page-builder/elements/parts/InputWithUnit";
import BorderControl from "@/components/page-builder/elements/parts/BorderControl";
import SpacingControl from "@/components/page-builder/elements/parts/SpacingControl";
import IconSelect from "@/components/page-builder/elements/parts/IconSelect";
import editor from "@tinymce/tinymce-vue";
import tinymceConfig from "@/tinymce/pbConfig";
import { getTinymce } from "@tinymce/tinymce-vue/lib/cjs/main/ts/TinyMCE";
//import hljs from "highlight.js";
import CodeEditor from "simple-code-editor";
export default {
    name: "ElementSettingProperty",
    components: {
        WordpressMediaLibraryModal,
        CreateBusinessDirectoryModal,
        PageLinkModal,
        draggable: VueDraggableNext,
        InputWithUnit,
        ColorChooser,
        ColorPicker,
        BorderControl,
        SpacingControl,
        IconSelect,
        editor,
        CodeEditor,
    },
    props: {
        element: {
            required: true,
            type: Object,
        },
        property: {
            required: true,
            type: Object,
        },
    },
    data: () => ({
        elementSetting: null,
        backupElementSetting: null,
        themeSettings: [],
        applyImage: null,
        faIcons: ["plus", "minus", "arrow-up", "arrow-down", "chevron-up", "chevron-down", "folder-open", "folder"],
        onlyImages: true,
        hasChanges: false,
        componentKey: 0,
        accordionSorting: false,
        businessDirectoryCategories: [],
        pageLinkMode: null,
        pageLinkAttr: null,
        linkTokenLabels: {},
        linkListCache: [],
        accordionIconSearch: "",
        accordionIconDropdownFor: null,
    }),

    watch: {
        // themeSettings load async (created) — usually after the TinyMCE editor has already
        // inited; push the theme font stylesheets into any live editor iframes when they arrive.
        themeSettings() {
            (this.fontEditors || []).forEach((ed) => this.injectEditorFonts(ed));
        },
    },

    mounted() {
        // Prevent Bootstrap dialog from blocking focusin
        document.addEventListener("focusin", (e) => {
            if (e.target.closest(".tox-tinymce-aux, .moxman-window, .tam-assetmanager-root") !== null) {
                e.stopImmediatePropagation();
            }
        });
        /* getTinymce().activeEditor.ui.hide(); */
        this.$nextTick(() => this.resolveLinkTokenLabels());
        this.loadLinkList();
    },

    updated() {
        this.accordionSorting = false;
    },

    async created() {
        this.fontEditors = [];
        this.elementSetting = this.element;
        this.backupElementSetting = JSON.parse(JSON.stringify(this.element));
        // NOTE: margin/padding are intentionally NOT defaulted to "0px 0px 0px 0px" here.
        // Doing so wrote an explicit zero into the payload just by opening the panel, which
        // then overrode the theme defaults (e.g. the twpb accordion button padding).
        // SpacingControl renders an unset value as zeros on its own.
        if (this.elementSetting.type == "ContentSlider" && !this.elementSetting.style.textAreaPadding) {
            this.elementSetting.style.textAreaPadding = "0px 0px 0px 0px";
        }
        if (this.elementSetting.type == "ContentSlider" && !this.elementSetting.style.textAreaMargin) {
            this.elementSetting.style.textAreaMargin = "0px 0px 0px 0px";
        }
        if (this.elementSetting.type == "ContentSlider" && !this.elementSetting.style.textAreaBorderRadius) {
            this.elementSetting.style.textAreaBorderRadius = "0px 0px 0px 0px";
        }
        this.themeSettings = await this.getClientThemeSetting();
        await this.loadBusinessDirectoryCategories();
        this.ensureBusinessDirectoryDefaults();
    },

    methods: {
        // Append the theme font stylesheets as <link>s directly into a TinyMCE iframe document
        // (TinyMCE doesn't honor @import in content_style, and content_css is set at init time
        // before themeSettings has loaded). Idempotent per editor + url.
        injectEditorFonts(editor) {
            try {
                if (!editor || typeof editor.getDoc !== "function") return;
                const doc = editor.getDoc();
                if (!doc || !doc.head) return;
                // 1) Load the webfont files as <link>s (reliable webfont loading in the iframe).
                if (!editor.__pbFonts) editor.__pbFonts = {};
                this.themeFontUrls.forEach((url) => {
                    if (editor.__pbFonts[url]) return;
                    editor.__pbFonts[url] = true;
                    const link = doc.createElement("link");
                    link.setAttribute("rel", "stylesheet");
                    link.setAttribute("href", url);
                    doc.head.appendChild(link);
                });
                // 2) (Re)inject the :root theme vars + body/heading font-family + sizes. These
                // live in content_style, which TinyMCE locks in at init time — BEFORE the async
                // themeSettings load resolves — so var(--hedings-font) would be undefined in the
                // iframe and the font-family never resolves even once the file is loaded.
                let styleEl = doc.getElementById("pb-theme-font-style");
                if (!styleEl) {
                    styleEl = doc.createElement("style");
                    styleEl.id = "pb-theme-font-style";
                    doc.head.appendChild(styleEl);
                }
                styleEl.textContent = this.themeFontContentStyle;
            } catch (e) {
                /* ignore */
            }
        },
        async loadBusinessDirectoryCategories() {
            if (this.elementSetting?.type !== "BusinessDirectory") {
                return;
            }
            const res = await this.getBusinessDirectoryCategories();
            this.businessDirectoryCategories = res?.data || [];
        },

        async openCreateBusinessDirectoryModal() {
            await this.$refs.createBusinessDirectoryModal.showModal(true);
        },

        async handleBusinessDirectorySaved() {
            await this.loadBusinessDirectoryCategories();
        },
        ensureBusinessDirectoryDefaults() {
            if (this.elementSetting?.type !== "BusinessDirectory") {
                return;
            }

            if (typeof this.elementSetting.props.showUncategorized !== "boolean") {
                this.elementSetting.props.showUncategorized = true;
            }

            if (!Array.isArray(this.elementSetting.props.visibleColumns) || !this.elementSetting.props.visibleColumns.length) {
                this.elementSetting.props.visibleColumns = ["image", "name", "email", "phone", "address"];
            }
        },
        shouldShowPropertyAttribute(attribute) {
            if (this.elementSetting?.type !== "BusinessDirectory") {
                return true;
            }

            if (attribute?.name === "showUncategorized") {
                return this.elementSetting?.props?.categoryMode === "all";
            }

            return true;
        },
        isBusinessDirectoryColumnSelected(value) {
            const selected = Array.isArray(this.elementSetting?.props?.visibleColumns) ? this.elementSetting.props.visibleColumns : [];
            return selected.includes(value);
        },
        toggleBusinessDirectoryColumn(value, checked) {
            if (!Array.isArray(this.elementSetting.props.visibleColumns)) {
                this.elementSetting.props.visibleColumns = [];
            }

            if (checked) {
                if (!this.elementSetting.props.visibleColumns.includes(value)) {
                    this.elementSetting.props.visibleColumns.push(value);
                }
            } else {
                this.elementSetting.props.visibleColumns = this.elementSetting.props.visibleColumns.filter((item) => item !== value);
            }

            if (!this.elementSetting.props.visibleColumns.length) {
                this.elementSetting.props.visibleColumns = ["image", "name", "email", "phone", "address"];
            }
            this.changeSetting();
        },
        showWordpressMediaLibraryModal(item) {
            this.applyImage = item;
            this.$refs.wordpressMediaLibraryModal.showModal(true);
        },

        insertPhoto(photoUrl) {
            // Check applyImage object and where to insert that selected image
            if (typeof this.applyImage == "object") {
                this.applyImage.image = photoUrl;
            } else {
                if (this.applyImage == "tiny") {
                    if (photoUrl.match(/\.(jpeg|jpg|gif|png)$/) != null) {
                        photoUrl = '<img src="' + photoUrl + '"/>';
                    } else {
                        photoUrl = '<a href="' + photoUrl + '">' + photoUrl + "</a>";
                    }
                    getTinymce().activeEditor.insertContent(photoUrl);
                } else {
                    if (this.applyImage.includes("props.")) {
                        this.elementSetting.props[this.applyImage.replace("props.", "")] = photoUrl;
                    } else if (this.applyImage.includes("style.")) {
                        this.elementSetting.style[this.applyImage.replace("style.", "")] = photoUrl;
                    } else {
                        this.elementSetting[this.applyImage] = photoUrl;
                    }
                }
            }
            this.changeSetting();
        },

        changeSetting() {
            this.$emit("elementSetting", this.elementSetting);
        },

        openWordpressMediaLibrary() {
            this.$refs.wordpressMediaLibraryModal.showModal(true, false);
        },

        changeValue(e, type) {
            if (type === "padding") {
                this.elementSetting.style.padding = e;
            }
            if (type === "labelPadding") {
                this.elementSetting.style.labelPadding = e;
            }
            if (type === "contentPadding") {
                this.elementSetting.style.contentPadding = e;
            }
            if (type === "headingPadding") {
                this.elementSetting.style.headingPadding = e;
            }
            if (type === "textPadding") {
                this.elementSetting.style.textPadding = e;
            }
            if (type === "margin") {
                this.elementSetting.style.margin = e;
            }
            if (type === "contentMargin") {
                this.elementSetting.style.contentMargin = e;
            }
            if (type === "radius") {
                this.elementSetting.style.borderRadius = e;
            }
            if (type === "textAreaPadding") {
                this.elementSetting.style.textAreaPadding = e;
            }
            if (type === "textAreaMargin") {
                this.elementSetting.style.textAreaMargin = e;
            }
            if (type === "textAreaBorderRadius") {
                this.elementSetting.style.textAreaBorderRadius = e;
            }
            if (type === "imageBorderRadius") {
                this.elementSetting.style.imageBorderRadius = e;
            }
            if (type === "textDecoration") {
                this.elementSetting.style.textDecoration = e;
            }
        },

        changeInputWithUnitValue(e, type) {
            if (type === "height") {
                this.elementSetting.style.height = e;
            }
            if (type === "width") {
                this.elementSetting.style.width = e;
            }
            if (type === "fontSize") {
                this.elementSetting.style.fontSize = e;
            }
            if (type === "labelFontSize") {
                this.elementSetting.style.labelFontSize = e;
            }
            if (type === "itemSpacing") {
                this.elementSetting.style.itemSpacing = e;
            }
            if (type === "fitWidth") {
                this.elementSetting.style.fitWidth = e;
            }
            if (type === "fitHeight") {
                this.elementSetting.style.fitHeight = e;
            }
            if (type === "border-width") {
                this.elementSetting.style.borderWidth = e;
            }
        },

        activateTab(tab) {
            this.property.tabs.forEach((t) => {
                t.active = false;
            });
            tab.active = true;
        },
        // Add properti item
        addPropertyItem(type) {
            if (type == "accordion") {
                let item = {
                    id: "accordion-item-" + Date.now() + "-" + this.elementSetting.props.items.length,
                    collapse: false,
                    title: "",
                    content: "",
                };
                this.elementSetting.props.items.push(item);
            }

            if (type == "tab") {
                let item = {
                    id: "tab-item-" + Date.now() + "-" + this.elementSetting.props.items.length,
                    active: false,
                    title: "",
                    content: "",
                };
                this.elementSetting.props.items.push(item);
            }

            if (type == "gallery") {
                let item = {
                    id: "gallery-item-" + Date.now() + "-" + this.elementSetting.props.items.length,
                    image: "",
                    title: "",
                };
                this.elementSetting.props.items.push(item);
            }

            if (type == "slider") {
                let item = {
                    id: "slider-item-" + Date.now() + "-" + this.elementSetting.props.items.length,
                    image: "",
                    title: "",
                    text: "",
                };
                this.elementSetting.props.items.push(item);
            }
            if (type == "contentSlider") {
                let item = {
                    id: "content-slider-item-" + Date.now() + "-" + this.elementSetting.props.items.length,
                    heading: "",
                    text: "",
                    image: "",
                    video: "",
                    type: "text",
                };
                this.elementSetting.props.items.push(item);
            }
        },

        setIcon(icon, state, prop) {
            let iconUnicode = this.getIconUnicode(icon);
            if (state === "open") {
                this.elementSetting.props[prop.replace("props.", "")] = iconUnicode;
            } else if (state === "close") {
                this.elementSetting.props[prop.replace("props.", "")] = iconUnicode;
            }

            this.changeSetting();
        },
        getIconUnicode(icon) {
            let iconUnicode = "";
            if (icon === "plus") {
                iconUnicode = "2b";
            } else if (icon === "minus") {
                iconUnicode = "f068";
            } else if (icon === "arrow-up") {
                iconUnicode = "f062";
            } else if (icon === "arrow-down") {
                iconUnicode = "f063";
            } else if (icon === "chevron-up") {
                iconUnicode = "f077";
            } else if (icon === "chevron-down") {
                iconUnicode = "f078";
            } else if (icon === "folder-open") {
                iconUnicode = "f07c";
            } else if (icon === "folder") {
                iconUnicode = "f07b";
            }
            return iconUnicode;
        },

        // heygov-style accordion icon picker (searchable; stores/reads the FA unicode hex)
        getIconNameFromHex(hexCode) {
            if (!hexCode) return "plus";
            const found = this.accordionIcons.find((ic) => ic.hex === hexCode);
            if (found) return found.name;
            // legacy codes stored by the old picker
            const legacy = { "2b": "plus", f062: "arrow-up", f063: "arrow-down", f07c: "folder-open", f07b: "folder" };
            return legacy[hexCode] || "plus";
        },
        accordionIconLabel(hexCode) {
            if (!hexCode) return "Default";
            const found = this.accordionIcons.find((ic) => ic.hex === hexCode);
            if (found) return found.label;
            const name = this.getIconNameFromHex(hexCode);
            return name.charAt(0).toUpperCase() + name.slice(1).replace(/-/g, " ");
        },
        toggleAccordionIconDropdown(attr) {
            this.accordionIconDropdownFor = this.accordionIconDropdownFor === attr ? null : attr;
            this.accordionIconSearch = "";
        },
        selectAccordionIcon(attr, hex) {
            this.elementSetting.props[attr.replace("props.", "")] = hex;
            this.accordionIconDropdownFor = null;
        },
        parseUnicodeIcon(unicodeIcon) {
            let icon = "";
            if (unicodeIcon === "2b") {
                icon = "plus";
            } else if (unicodeIcon === "f068") {
                icon = "minus";
            } else if (unicodeIcon === "f062") {
                icon = "arrow-up";
            } else if (unicodeIcon === "f063") {
                icon = "arrow-down";
            } else if (unicodeIcon === "f077") {
                icon = "chevron-up";
            } else if (unicodeIcon === "f078") {
                icon = "chevron-down";
            } else if (unicodeIcon === "f07c") {
                icon = "folder-open";
            } else if (unicodeIcon === "f07b") {
                icon = "folder";
            }
            return icon;
        },

        // Remove Gallery item
        removePropertyItem(id) {
            this.elementSetting.props.items = this.elementSetting.props.items.filter((item) => item.id !== id);
        },

        tinyMCEMedLib(event) {
            if (event.command === "openMediaLib") {
                this.applyImage = "tiny";
                this.openWordpressMediaLibrary();
            }
        },
        // open the page picker to fill a link chooser attribute (Button/Photo "Link")
        openPageLinkForAttr(attr) {
            this.pageLinkMode = "attr";
            this.pageLinkAttr = attr;
            this.$refs.pageLinkModal.showModal();
        },
        // preload the internal-links list so TinyMCE's "Internal links" dropdown is populated
        async loadLinkList() {
            try {
                if (this.$refs.pageLinkModal && this.$refs.pageLinkModal.getLinkList) {
                    this.linkListCache = await this.$refs.pageLinkModal.getLinkList();
                }
            } catch (e) {
                /* ignore */
            }
        },
        // a chosen page becomes a stable token {##entity:Page:id##}; Juniper resolves it to
        // the real URL on render (PBHelper::replaceInternalLinkTokens) — same as heygov.
        onPageSelected(page) {
            if (!page) return;
            const token = page.kind === "archive" ? "{##archive:" + page.key + "##}" : "{##entity:" + (page.entity || "Page") + ":" + page.id + "##}";
            this.linkTokenLabels[token] = page.path || page.title;
            if (this.pageLinkMode === "editor") {
                const ed = getTinymce().activeEditor;
                if (ed) {
                    const selected = ed.selection.getContent({ format: "text" });
                    const text = selected && selected.trim() !== "" ? selected : page.title;
                    ed.insertContent('<a href="' + token + '">' + text + "</a>");
                }
            } else if (this.pageLinkMode === "attr" && this.pageLinkAttr) {
                const a = this.pageLinkAttr;
                if (a.includes("props.")) this.elementSetting.props[a.replace("props.", "")] = token;
                else if (a.includes("style.")) this.elementSetting.style[a.replace("style.", "")] = token;
                else this.elementSetting[a] = token;
            }
            this.pageLinkMode = null;
            this.pageLinkAttr = null;
        },
        isLinkToken(v) {
            return /^\{##(entity|archive):/.test(v || "");
        },
        linkTokenLabel(v) {
            if (this.linkTokenLabels[v]) return this.linkTokenLabels[v];
            const e = /^\{##entity:(\w+):(\d+)##\}$/.exec(v || "");
            if (e) return e[1] + " #" + e[2];
            const a = /^\{##archive:(\w+)##\}$/.exec(v || "");
            if (a) return a[1];
            return "Internal link";
        },
        // resolve display names for saved link tokens on the current element (chip labels)
        resolveLinkTokenLabels() {
            const props = this.elementSetting && this.elementSetting.props;
            if (!props || !this.$refs.pageLinkModal) return;
            Object.keys(props).forEach((k) => {
                const v = props[k];
                if (typeof v !== "string") return;
                const m = /^\{##entity:(\w+):(\d+)##\}$/.exec(v);
                if (m && !this.linkTokenLabels[v]) {
                    this.$refs.pageLinkModal.resolveToken(m[1], m[2]).then((info) => {
                        if (info) this.linkTokenLabels[v] = info.path || info.title;
                    });
                }
            });
        },

        handleMediaInsert(content) {
            if (content.match(/\.(jpeg|jpg|gif|png)$/) != null) {
                content = '<img src="' + content + '"/>';
            } else {
                content = '<a href="' + content + '">' + content + "</a>";
            }

            getTinymce().activeEditor.insertContent(content);
        },
        closeElementSetting() {
            this.$emit("close");
        },
        cancelChanges() {
            this.assignObjectValues(this.elementSetting, this.backupElementSetting);
            this.$emit("close");
        },
        assignObjectValues(targetObj, sourceObj) {
            for (let key in sourceObj) {
                if (Object.prototype.hasOwnProperty.call(sourceObj, key)) {
                    if (typeof sourceObj[key] === "object" && sourceObj[key] !== null) {
                        if (!Object.prototype.hasOwnProperty.call(targetObj, key)) {
                            targetObj[key] = {};
                        }
                        this.assignObjectValues(targetObj[key], sourceObj[key]);
                    } else {
                        targetObj[key] = sourceObj[key];
                    }
                }
            }
        },
        onDragEnd: function (evt, type) {
            if (type === "accordion") {
                this.accordionSorting = true;
                this.componentKey += 1;
            }
        },
    },
    computed: {
        tinymcInit() {
            // link_list adds a "Link list" picker (grouped site pages) to TinyMCE's native
            // Insert/Edit Link dialog, so there's a single link button (no separate one).
            return {
                ...tinymceConfig.config,
                link_list: (success) => {
                    if (this.linkListCache && this.linkListCache.length) {
                        success(this.linkListCache);
                    } else if (this.$refs.pageLinkModal && this.$refs.pageLinkModal.getLinkList) {
                        this.$refs.pageLinkModal
                            .getLinkList()
                            .then((list) => {
                                this.linkListCache = list;
                                success(list);
                            })
                            .catch(() => success([]));
                    } else {
                        success([]);
                    }
                },
                // TinyMCE renders content in an iframe, so the page's theme-font CSS/vars
                // don't reach it — inject them here so the editing area matches the theme.
                // themeFontContentStyle MUST come first: its @import (Google Fonts) is only
                // honored when it precedes every other rule in the stylesheet.
                content_style: this.themeFontContentStyle + (tinymceConfig.config.content_style || ""),
                // Load the theme fonts as real <link> stylesheets inside the iframe. TinyMCE
                // does not reliably honor @import in content_style, so the webfont file must be
                // pulled via content_css. "default" keeps the editor's base content styling.
                content_css: ["default"].concat(this.themeFontUrls),
                // The editor usually initializes BEFORE the async themeSettings load resolves,
                // and tinymce-vue does not re-init on :init change — so inject the font <link>s
                // into the iframe imperatively once the editor is ready (the themeSettings
                // watcher re-injects into live editors when settings arrive after init).
                init_instance_callback: (editor) => {
                    if (!this.fontEditors) this.fontEditors = [];
                    if (this.fontEditors.indexOf(editor) === -1) this.fontEditors.push(editor);
                    editor.on("remove", () => {
                        this.fontEditors = (this.fontEditors || []).filter((e) => e !== editor);
                    });
                    this.injectEditorFonts(editor);
                },
            };
        },
        // Google Fonts stylesheet URLs for the theme fonts (same import the published site and
        // the canvas use), loaded into the TinyMCE iframe via content_css.
        themeFontUrls() {
            const urls = [];
            (this.themeSettings || []).forEach((s) => {
                if (!s || !s.code || s.code === "FIGMA_VARIABLES") return;
                const name = s.code.toLowerCase().replace(/_/g, "-");
                if (s.value && name.indexOf("font") !== -1 && !String(s.value).startsWith("TownWeb ") && !String(s.value).endsWith(" TownWeb")) {
                    const url = "https://fonts.googleapis.com/css?family=" + String(s.value).replace(/ /g, "+") + ":ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap";
                    if (urls.indexOf(url) === -1) urls.push(url);
                }
            });
            return urls;
        },
        // @import + :root vars + body/heading font-family, derived from the theme settings,
        // for injection into the TinyMCE content iframe (mirrors getCustomizerSettingsCSS).
        themeFontContentStyle() {
            let importFont = "";
            let vars = ":root{";
            (this.themeSettings || []).forEach((s) => {
                if (!s || !s.code || s.code === "FIGMA_VARIABLES") return;
                const name = s.code.toLowerCase().replace(/_/g, "-");
                if (s.value && name.indexOf("font") !== -1 && !String(s.value).startsWith("TownWeb ") && !String(s.value).endsWith(" TownWeb")) {
                    importFont += "@import url('https://fonts.googleapis.com/css?family=" + String(s.value).replace(/ /g, "+") + ":ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');";
                }
                if (s.value !== undefined && s.value !== null && s.value !== "") vars += "--" + name + ":" + s.value + ";";
            });
            vars += "}";
            // headings get the theme heading font AND theme sizes (var(--hN-size)), matching the canvas
            const headingSizes = "h1{font-size:var(--h1-size,36px);}h2{font-size:var(--h2-size,30px);}h3{font-size:var(--h3-size,24px);}h4{font-size:var(--h4-size,18px);}h5{font-size:var(--h5-size,14px);}h6{font-size:var(--h6-size,12px);}";
            return importFont + vars + "body{font-family:var(--primary-font, inherit);}h1,h2,h3,h4,h5,h6{font-family:var(--hedings-font, var(--primary-font, inherit));}" + headingSizes;
        },
        // Accordion icon picker set (same icons/hex as the new builder; library.add(fas) has them all)
        accordionIcons() {
            return [
                { hex: "f078", name: "chevron-down", label: "Chevron Down" },
                { hex: "f077", name: "chevron-up", label: "Chevron Up" },
                { hex: "f054", name: "chevron-right", label: "Chevron Right" },
                { hex: "f053", name: "chevron-left", label: "Chevron Left" },
                { hex: "f107", name: "angle-down", label: "Angle Down" },
                { hex: "f106", name: "angle-up", label: "Angle Up" },
                { hex: "f105", name: "angle-right", label: "Angle Right" },
                { hex: "f104", name: "angle-left", label: "Angle Left" },
                { hex: "f067", name: "plus", label: "Plus" },
                { hex: "f068", name: "minus", label: "Minus" },
                { hex: "f055", name: "plus-circle", label: "Plus Circle" },
                { hex: "f056", name: "minus-circle", label: "Minus Circle" },
                { hex: "f0fe", name: "plus-square", label: "Plus Square" },
                { hex: "f146", name: "minus-square", label: "Minus Square" },
                { hex: "f0d7", name: "caret-down", label: "Caret Down" },
                { hex: "f0d8", name: "caret-up", label: "Caret Up" },
                { hex: "f0da", name: "caret-right", label: "Caret Right" },
                { hex: "f0d9", name: "caret-left", label: "Caret Left" },
            ];
        },
        filteredAccordionIcons() {
            const q = this.accordionIconSearch.trim().toLowerCase();
            if (!q) return this.accordionIcons;
            return this.accordionIcons.filter((ic) => ic.label.toLowerCase().includes(q) || ic.name.includes(q));
        },
        businessDirectoryColumnOptions() {
            return [
                { value: "image", label: "Image" },
                { value: "name", label: "Name" },
                { value: "email", label: "Email" },
                { value: "phone", label: "Phone" },
                { value: "address", label: "Address" },
                { value: "socials", label: "Socials" },
                { value: "website", label: "Website" },
                { value: "category", label: "Category" },
                { value: "date", label: "Date" },
            ];
        },
    },
    mixins: [pageBuilderMixin],
};
</script>

<style scoped>
.accordion-button.collapsed::after {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
}

.element-setting-contant-group .group-name {
    margin-bottom: 0;
}
.element-setting-contant-group .group-help {
    font-size: 11px;
}

.element-item {
    position: relative;
}

.element-item-remove {
    position: absolute;
    right: -15px;
    top: 0px;
    border-radius: 50%;
}

.gallery-item {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    padding: 10px;
    border-radius: 10px;
}

.gallery-item .content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    background-color: #f8f7f7;
    width: 100%;
    min-height: 100px;
    border-radius: 10px;
    padding: 0px 10px;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.gallery-item .content input {
    border-radius: 5px !important;
    background-color: transparent;
    border: none;
    margin: 10px;
    width: 100%;
    padding-left: 5px;
    background-color: white;
}

.gallery-item .content select {
    border-radius: 5px !important;
    background-color: transparent;
    border: none;
    margin: 10px;
    padding-left: 5px;
    background-color: white;
}

.gallery-item .content textarea {
    border-radius: 5px !important;
    background-color: transparent;
    border: none;
    margin: 10px;
    width: 100%;
    padding-left: 5px;
    background-color: white;
}

.gallery-item .content .actions {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background-color: #f8f7f7;
    padding: 5px;
}

.gallery-item .image {
    min-width: 100px;
    width: 100px;
    height: 100px;
    object-fit: cover;
    cursor: pointer;
    border-radius: 10px;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.gallery-item .gallery-item-no-image {
    min-width: 100px;
    width: 100px;
    height: 100px;
    background-color: #f8f7f7;
    border-radius: 10px;
    color: #4e6078;
    text-transform: uppercase;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.gallery-item .video {
    min-width: 100px;
    width: 100px;
    height: 100px;
    object-fit: cover;
    cursor: pointer;
    border-radius: 10px;

    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.gallery-item .video textarea {
    min-width: 100px;
    width: 100px;
    height: 100px;
    object-fit: cover;
    cursor: pointer;
    border-radius: 10px !important;
    border: none;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
    font-size: 12px;
    padding: 5px;
}

.gallery-item .image span {
    position: absolute;
    background-color: rgba(255, 255, 255, 0.5);
    padding: 2px;
    border-bottom-right-radius: 7px;
}

.gallery-item .image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    cursor: pointer;
    border-radius: 10px;
}

.gallery-item-content-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: start;
    align-items: start;
    flex-direction: column;
}

.chooser-element {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.chooser-element-title {
    font-size: 12px;
    width: 200px;
}
.chooser-element-title .title {
    color: #333;
}
.chooser-element-title .title-help {
    font-size: 12px;
    cursor: pointer;
}
.chooser-element-content {
    min-width: 275px;
}
/* every MAIN chooser control (direct child) gets a uniform minimum width; nested controls
   inside flex rows (opacity, image src, item editors) are left alone via the child combinator */
.chooser-element-content > .form-select,
.chooser-element-content > .form-control {
    min-width: 275px;
    display: inline-block;
}
.chooser-element-content > textarea.form-control {
    display: block;
    width: 100%;
}
.remove-gallery-item {
    position: absolute;
    right: 0px;
    top: 0px;
    border-radius: 50%;
}

.text-input {
    border-color: transparent !important;
    border-style: solid;
    border-width: 2px;
    border-radius: 4px !important;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);
    color: #333 !important;
    display: inline;
    font-size: 13px;
}

.select-input {
    border-color: transparent !important;
    border-style: solid;
    border-width: 2px;
    border-radius: 4px !important;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);
    color: #333 !important;
    display: inline;
    font-size: 13px;
}

/* Unify EVERY chooser control to the color-picker look: white, soft shadow, ~32px tall,
   no heavy borders — so selects/inputs/spacing/align all match instead of varying. */
.chooser-element-content .form-select,
.chooser-element-content .form-control {
    background-color: #fff !important;
    border: none !important;
    border-radius: 4px !important;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12) !important;
    height: 31.5px;
    min-height: 31.5px;
    font-size: 13px;
    color: #333 !important;
}
.chooser-element-content .form-select {
    padding: 2px 28px 2px 10px;
}
.chooser-element-content .form-control {
    padding: 2px 10px;
}
.chooser-element-content textarea.form-control {
    height: auto;
    min-height: 64px;
    padding: 6px 10px;
}

.chooser-align-wrapper {
    background: #e7ebef;
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);
    display: flex;
    float: left;
    height: 31.5px;
}

.align-btn {
    cursor: pointer;
    display: flex;
    flex: 1 1 auto;
    align-items: center;
    justify-content: center;
    padding: 0 5px;
    border-radius: 0px;
    border: 2px solid transparent;
    background: transparent !important;
    width: 40px;
}
.align-btn:hover {
    box-shadow: none;
    transform: none;
}
.align-btn.active {
    background-color: white !important;
}
.form-check-input {
    cursor: pointer;
}
/* Accordion icon picker (heygov-style searchable dropdown, old skin) */
.pb-icon-select {
    position: relative;
    min-width: 275px;
}
.pb-icon-control {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    width: 100%;
    height: 31.5px;
    padding: 2px 10px;
    background: #fff;
    border: none;
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);
    font-size: 13px;
    color: #333;
    cursor: pointer;
}
.pb-icon-current {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    overflow: hidden;
    white-space: nowrap;
}
.pb-icon-name {
    overflow: hidden;
    text-overflow: ellipsis;
}
.pb-icon-caret {
    font-size: 11px;
    color: #9ca3af;
    transition: transform 0.15s ease;
}
.pb-icon-caret.open {
    transform: rotate(180deg);
}
.pb-icon-dropdown {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    right: 0;
    z-index: 1050;
    background: #fff;
    border-radius: 6px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.18);
    padding: 8px;
    max-height: 260px;
    display: flex;
    flex-direction: column;
}
.pb-icon-search {
    margin-bottom: 8px;
    flex-shrink: 0;
}
.pb-icon-list {
    overflow-y: auto;
}
.pb-icon-option {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 6px 8px;
    border: none;
    background: transparent;
    border-radius: 4px;
    font-size: 13px;
    color: #333;
    cursor: pointer;
    text-align: left;
}
.pb-icon-option:hover {
    background: #f3f4f6;
}
.pb-icon-option.active {
    background: #e7ebef;
    color: #2563eb;
}
.pb-icon-glyph {
    width: 18px;
    text-align: center;
    color: #6b7280;
}
.pb-icon-option.active .pb-icon-glyph {
    color: #2563eb;
}
.pb-icon-empty {
    padding: 10px;
    text-align: center;
    color: #9ca3af;
    font-size: 12px;
}
</style>
